class WishlistSort extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.onSortChange = this.onSortChange.bind(this)

    this.listeners.add(this.els.select.element, 'change', this.onSortChange)
  }

  onSortChange (e) {
    const params = this.searchParams
    if (e.target.value !== '') {
      params.sort = e.target.value
    } else {
      delete params.sort
    }
    const paramsString = new URLSearchParams(params).toString()
    window.location.href = `${location.protocol}//${location.host}${
      location.pathname
    }${paramsString ? '?' : ''}${paramsString}`
  }

  get searchParams () {
    const urlSearchParams = new URLSearchParams(window.location.search)
    return Object.fromEntries(urlSearchParams.entries())
  }
}

customElements.define('wishlist-sort', WishlistSort)
